import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CartConfirmAddress from "./CartConfirmAddress";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import Factor from "./Factor";
import {
  useGetDeliveriesQuery,
  useGetOrderQuery,
  useNavigatePaymentPageMutation,
  useSetDeliveryOrderMutation,
  useSetGateTypeOrderMutation,
  useUpdateAddressOrderMutation,
} from "../../../../Store/Slices/rtk";
import { useGetPaymentsQuery } from "../../../../Store/Slices/PaymentsSlice/paymentApi";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { GradientBorderBox } from "../../../../Components";

export default function CartConfirm() {
  const theme = useTheme();
  const navigate = useNavigate();

  // order Get
  const orderSct = useGetOrderQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  // get payment url
  const [getPaymentUrlPage, { isLoading }] = useNavigatePaymentPageMutation();
  // get delivery types
  const { data: deliveryTypeData } = useGetDeliveriesQuery();
  // get payment types
  const { data: paymentsData } = useGetPaymentsQuery();
  // update Address
  const [updateAddressOrder, {}] = useUpdateAddressOrderMutation();
  // update gateWay
  const [setGateTypeOrder, {}] = useSetGateTypeOrderMutation();
  // update gateWay
  const [setDeliveryOrder, {}] = useSetDeliveryOrderMutation();

  // const [fullCartClear, {}] = useFullClearMutation();

  const [orderEntries, setOrderEntries] = useState({
    selectedAddress: "",
    isOnlinePay: "",
    selectedDelivery: "",
  });
  const [deliveryLoading, setDeliveryLoading] = useState(false);
  const [addressLoading, setAddressLoading] = useState(false);

  // Handle Order Entries Change
  const handleOrderEntries = (key, value) => {
    setOrderEntries({ ...orderEntries, [key]: value });
  };

  // Handle Delivery Change
  const handleDeliveryChange = async (code) => {
    setDeliveryLoading(true);

    try {
      const setDeliveryOrderRes = await setDeliveryOrder({
        deliveryCode: code,
        orderCode: orderSct?.data?.data?.code,
      });
      if (setDeliveryOrderRes?.data.status != "ok") {
        toast.error("مشکلی در نحوه ارسال پیش آمد");
      }
      handleOrderEntries("selectedDelivery", code);
      orderSct.refetch();
    } catch (error) {
      toast.error("مشکلی در نحوه ارسال پیش آمد");
    }

    setDeliveryLoading(false);
  };

  // Handle Address Change
  const handleAddressChange = async (code) => {
    setAddressLoading(true);

    try {
      const setAddressRes = await updateAddressOrder({
        adCode: code,
        orderCode: orderSct?.data?.data?.code,
      });
      if (setAddressRes?.data.status != "ok") {
        toast.error("مشکلی در نحوه ارسال پیش آمد");
      }
      handleOrderEntries("selectedAddress", code);
      orderSct.refetch();
    } catch (error) {
      toast.error("مشکلی در نحوه ارسال پیش آمد");
    }

    setAddressLoading(false);
  };

  // Handle Btn Payment clicked
  const handleSubmit = async () => {
    try {
      if (!orderSct?.data?.data?.code) {
        return toast.error("!لطفا کمی صبر کنید");
      }
      if (!orderEntries?.selectedAddress) {
        return toast.error("!لطفا آدرس را انتخاب کنید");
      }
      // Update Address
      // const addressRes = await updateAddressOrder({
      //   adCode: orderEntries?.selectedAddress,
      //   orderCode: orderSct?.data?.data?.code,
      // });

      // if (addressRes?.data.status != "ok") {
      //   return toast.error("مشکلی پیش آمد، آدرس را تغییر دهید");
      // }

      // OnlineGate
      const setGateTypeOrderRes = await setGateTypeOrder({
        gateCode: orderEntries?.isOnlinePay,
        orderCode: orderSct?.data?.data?.code,
      });

      if (setGateTypeOrderRes?.data.status != "ok") {
        return toast.error("مشکلی پیش آمد، درگاه پرداخت را تغییر دهید");
      }

      // set Delivery
      // const setDeliveryOrderRes = await setDeliveryOrder({
      //   deliveryCode: deliveryTypeData?.data?.[0]?.code,
      //   orderCode: orderSct?.data?.data?.code,
      // });
      // if (setDeliveryOrderRes?.data.status != "ok") {
      //   return toast.error("مشکلی در نحوه ارسال پیش آمد");
      // }

      const getUrlPaymentPage = await getPaymentUrlPage();
      // console.log(getUrlPaymentPage , getUrlPaymentPage?.data?.status , getUrlPaymentPage?.data?.data?.redirect_url)
      if (getUrlPaymentPage?.data?.status != "ok") {
        return toast.error("!مشکلی در ثبت سفارش پیش آمد");
      }

      if (!getUrlPaymentPage?.data?.data?.redirect_url) {
        return toast.error("مشکلی در دریافت درگاه پرداخت پیش آمد");
      }
      // redirect to paYMENT
      window.location.href = getUrlPaymentPage?.data?.data?.redirect_url;
      return toast.success("در حال انتقال به درگاه پرداخت");
    } catch (error) {
      console.log(error);
      toast.error(error.massage || "مشکلی پیش آمد لطفا کمی صبر کنید !");
    }
  };

  // to auto save payment type and delivery
  useEffect(() => {
    handleOrderEntries("isOnlinePay", paymentsData?.data?.data?.[0]?.code);
  }, [paymentsData]);

  // Gate Way Items
  const gateWaysItem = paymentsData?.data?.data?.map((e, index) => {
    return (
      <Box
        key={index}
        onClick={() => handleOrderEntries("isOnlinePay", e?.code)}
        sx={{
          width: "70px",
          height: "85px",
          boxShadow:
            orderEntries?.isOnlinePay == e?.code
              ? "0px 0px 11.4px 0px #5F9CC2"
              : "",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        <img
          style={{ width: "100%", height: "100%" }}
          src={import.meta.env.VITE_URL + e?.image}
          alt={e?.title}
        />
      </Box>
    );
  });

  // delivery items
  const deliveriesItem = deliveryTypeData?.data?.map((e, index) => {
    const isSelected = orderEntries?.selectedDelivery === e?.code;

    return (
      <Box
        key={index}
        onClick={() => handleDeliveryChange(e?.code)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "8px",
          px: "12px",
          py: "10px",
          borderRadius: "8px",
          cursor: "pointer",
          border: "1px solid",
          borderColor: !isSelected ? "transparent" : theme.palette.primary.main,
          bgcolor: isSelected
            ? theme.palette.background.paper
            : theme.palette.background.paper,
          transition: "all 0.2s ease",
          "&:hover": {
            boxShadow: ` 0px 0px 5px 1px ${theme.palette.primary.light}`,
          },
        }}
      >
        {/* Right side: title */}
        <Typography
          sx={{
            fontSize: ".9rem",
            // fontWeight: isSelected ? 600 : 400,
          }}
        >
          {e?.name}
        </Typography>

        {/* Left side: radio icon */}
        {deliveryLoading ? (
          <CircularProgress size={"1.5rem"} />
        ) : isSelected ? (
          <RadioButtonCheckedIcon sx={{ color: theme.palette.primary.main }} />
        ) : (
          <RadioButtonUncheckedIcon sx={{ color: "#999" }} />
        )}
      </Box>
    );
  });

  return (
    <>
      <Stack
        sx={{
          width: "100%",
          maxWidth: "1440px",
          mx: "auto",
          px: "2rem",
          gap: "1rem",
          mt: "5rem",
          justifyContent: "center",
          alignItems: { xs: "center", md: "flex-start" },
        }}
        direction={{ xs: "column", md: "row" }}
      >
        {/* Factor */}
        <Factor order={orderSct} />

        {/* Addresses and GateWay */}
        <Stack sx={{ width: { xs: "100%", sm: "70%" } }}>
          {/* Addresses */}
          <CartConfirmAddress
            orderEntries={orderEntries}
            handleOrderEntries={handleOrderEntries}
            handleAddressChange={handleAddressChange}
            addressLoading={addressLoading}
          />

          {/* GateWay */}
          <Stack
            sx={{
              pt: "2rem",
              direction: "rtl",
            }}
          >
            <Typography
              sx={{
                color: theme.palette.primary.main,
                fontSize: "1.2rem",
              }}
            >
              انتخاب درگاه پرداخت
            </Typography>
            <Stack
              direction={"row"}
              sx={{ gap: "1rem", mt: "1rem", flexWrap: "wrap" }}
            >
              {gateWaysItem}
            </Stack>
          </Stack>
          {/* Delivery Type */}
          <Stack
            sx={{
              pt: "2rem",
              direction: "rtl",
            }}
          >
            <Typography
              sx={{
                color: theme.palette.primary.main,
                fontSize: "1.2rem",
              }}
            >
              انتخاب نوع تحویل
            </Typography>
            <Stack
              direction={"row"}
              sx={{ gap: "1rem", mt: "1rem", flexWrap: "wrap" }}
            >
              {deliveriesItem}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      {/* Button */}
      <Stack
        direction={"row"}
        sx={{
          width: { xs: "90%", sm: "100%" },
          mx: "auto",
          maxWidth: { xs: "350px", md: "600px" },
          minWidth: "300px",
          borderRadius: "6px",
          padding: "8px",
          gap: ".5rem",
          my: "2rem",
          position: "relative",
        }}
      >
        <Button
          onClick={() => handleSubmit()}
          sx={{ width: "100%", zIndex: "10" }}
          size="large"
          disabled={isLoading}
          variant="contained"
        >
          پرداخت
        </Button>
        <Button
          onClick={() => navigate(-1)}
          sx={{ width: "100%", zIndex: "10" }}
          size="large"
          variant="outlined"
        >
          مرحله قبل
        </Button>
        <GradientBorderBox
          bgGrad={`linear-gradient(
    -35deg,
    ${theme.palette.primary.main} 0%,
    ${theme.palette.background.default} 45%,
    ${theme.palette.background.default} 55%,
     ${theme.palette.background.white} 100%
  )`}
          radius=".25em"
        />
      </Stack>
    </>
  );
}
